import { render, staticRenderFns } from "./CargoHierarchyDetails.vue?vue&type=template&id=2b42d2aa&scoped=true"
import script from "./CargoHierarchyDetails.vue?vue&type=script&lang=js"
export * from "./CargoHierarchyDetails.vue?vue&type=script&lang=js"
import style0 from "./CargoHierarchyDetails.vue?vue&type=style&index=0&id=2b42d2aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b42d2aa",
  null
  
)

export default component.exports